
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Phase I: Fini le confinement`}</h3>
    <p>{`Les `}<strong parentName="p">{`grands magasins`}</strong>{` et les `}<strong parentName="p">{`piscine`}</strong>{` sont à nouveau ouverts; les
`}<strong parentName="p">{`bureaux`}</strong>{` `}<em parentName="p">{`open space`}</em>{` sont de plus en plus fréquentés et les `}<strong parentName="p">{`transports
publiques`}</strong>{` sont à nouveau bondés aux heures de pointe. Malgré la distanciation
physique et le respect des règles d'hygiène, de `}<strong parentName="p">{`nouvelles infections`}</strong>{`
surviennent.`}</p>
    <p><strong parentName="p">{`Lundi`}</strong>{` 29 juin, une semaine fantastique s'annonce! Vous quittez votre
`}<strong parentName="p">{`domicile`}</strong>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;